/*
 *             Copyright (c) 2016 - 2023, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
'use strict';var __importDefault=this&&this['__importDefault']||function(_0x1b3787){return _0x1b3787&&_0x1b3787['__esModule']?_0x1b3787:{'default':_0x1b3787};};Object['defineProperty'](exports,'__esModule',{'value':!0x0});const message_1=__importDefault(require('../../../message'));class PackageDataMessage extends message_1['default']{static['create'](_0x5ab55d,_0x1fb7a0){throw new TypeError('Must\x20be\x20implemented\x20in\x20a\x20child\x20class!');}}exports['default']=PackageDataMessage,module['exports']=PackageDataMessage;